import dayjs from "dayjs";

/**
 * 时间格式化工具
 * @param {String|Number|Date} time - 时间戳或日期字符串
 * @param {String} format - 格式模板，例如 'YYYY-MM-DD HH:mm:ss'
 * @returns {String} 格式化后的时间字符串
 */
// 使用示例
// const timeStr = '2025-05-29T09:46:41';
// console.log(formatTime(timeStr)); // 输出: 2025-05-29 09:46:41
// console.log(formatTime(timeStr, 'YYYY年MM月DD日')); // 输出: 2025年05月29日
export function formatTime(time, format = 'YYYY-MM-DD HH:mm:ss') {
  if (!time) return '';

  // 转换为 Date 对象
  let date;
  if (time instanceof Date) {
    date = time;
  } else if (typeof time === 'string') {
    // 处理带 T 的 ISO 格式（如 2025-05-29T09:46:41）
    if (time.includes('T')) {
      date = new Date(time.replace('T', ' ').replace(/-/g, '/'));
    } else {
      date = new Date(time);
    }
  } else if (typeof time === 'number') {
    // 处理时间戳（毫秒）
    date = new Date(time);
  } else {
    return time;
  }

  // 格式化函数
  const formatObj = {
    YYYY: date.getFullYear(),
    MM: String(date.getMonth() + 1).padStart(2, '0'),
    DD: String(date.getDate()).padStart(2, '0'),
    HH: String(date.getHours()).padStart(2, '0'),
    mm: String(date.getMinutes()).padStart(2, '0'),
    ss: String(date.getSeconds()).padStart(2, '0')
  };

  // 替换模板中的占位符
  return format.replace(/YYYY|MM|DD|HH|mm|ss/g, (match) => formatObj[match]);
  // return format.replace(/YYYY|MM|DD/g, (match) => formatObj[match]);
}






// Thu Jul 10 2025 00:00:00 GMT+0800 (GMT+08:00)  转化为2023-10-01T12:00:00
export function formatToISO(dateString) {

  if (!dateString) {
    return '';
  }

  // 处理传入的日期字符串
  const date = new Date(dateString);

  // 检查日期是否有效
  if (isNaN(date.getTime())) {
    console.error('Invalid date:', dateString);
    return '';
  }

  // 生成 ISO 格式的日期部分
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  // 生成 ISO 格式的时间部分
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  // 组合成完整的 ISO 格式字符串
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}


//  \n 或 \n\n 正确转换为 HTML 换行
export function replaceNewlinesWithBr(value) {
  if (!value) return '';
  return value.replace(/\n/g, '<br>');
};


// 把时间戳转化成正常值
export function formatTs(ts, fmt = 'YYYY-MM-DD HH:mm:ss') {
  if (!ts) return ''
  const t = ts.toString().length === 10 ? ts * 1000 : ts   // 秒→毫秒
  return dayjs(t).format(fmt)
}


/**
 * 格式化日期为相对时间（几分钟前、几小时前等）
 * @param {string|number} dateString - 日期字符串（如 '2023-10-27T10:00:00Z'）或时间戳
 * @returns {string} 格式化后的相对时间字符串
 */
export function formatRelativeTime(dateString) {
  if (!dateString) return '';

  const messageTime = typeof dateString === 'string' 
    ? new Date(dateString).getTime() 
    : dateString;
    
  const now = new Date().getTime();
  const diff = now - messageTime;

  const second = 1000;
  const minute = second * 60;
  const hour = minute * 60;
  const day = hour * 24;
  const month = day * 30;
  const year = day * 365;

  if (diff < 0) return '未来时间';
  if (diff < minute) return '刚刚';
  if (diff < hour) return `${Math.floor(diff / minute)}分钟前`;
  if (diff < day) return `${Math.floor(diff / hour)}小时前`;
  if (diff < month) return `${Math.floor(diff / day)}天前`;
  if (diff < year) return `${Math.floor(diff / month)}个月前`;
  return `${Math.floor(diff / year)}年前`;
}

